import '@naturehouse/design-system/components/atoms/char-count/CharCount';
import '@naturehouse/design-system/components/molecules/text-area-char-count/TextAreaCharCount';
import FormSubmitButtonHandler from '../../common/forms/FormSubmitButtonHandler';
import '../../../css/views/review.pcss';

(function reviewFormInit(): void {
    const form: HTMLFormElement | null = document.querySelector('form[name="create_review_form"]');
    if (!form) return;

    FormSubmitButtonHandler.handle(form);
})();
